var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndividualSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26.25 80C40.7475 80 52.5 68.2475 52.5 53.75C52.5 39.2525 40.7475 27.5 26.25 27.5C11.7525 27.5 0 39.2525 0 53.75C0 68.2475 11.7525 80 26.25 80Z",
    fill: "#E53B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 80V68.75",
    stroke: "#374354",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.75 68.75V80",
    stroke: "#374354",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 62.5V67.5C57.5 68.1912 56.9412 68.75 56.25 68.75H38.75C38.0588 68.75 37.5 68.1912 37.5 67.5V62.5",
    stroke: "#374354",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 63.75C64.7589 63.75 78.75 49.7589 78.75 32.5C78.75 15.2411 64.7589 1.25 47.5 1.25C30.2411 1.25 16.25 15.2411 16.25 32.5C16.25 49.7589 30.2411 63.75 47.5 63.75Z",
    stroke: "#374354",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.75 25.625C53.75 30 51.2962 33.75 47.5 33.75C43.7038 33.75 41.25 30 41.25 25.625C41.25 21.25 42.5 18.75 47.5 18.75C52.5 18.75 53.75 21.25 53.75 25.625Z",
    stroke: "#E53B34",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.25 32.5L60 37.5C60 37.5 60 37.93 60 40C60 42.07 58.75 43.75 57.5 43.75H37.5C36.25 43.75 35 42.07 35 40C35 37.93 35 37.5 35 37.5L43.75 32.5",
    stroke: "#E53B34",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 72.5V80",
    stroke: "#E53B34",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 58.75C61.9975 58.75 73.75 46.9975 73.75 32.5C73.75 18.0025 61.9975 6.25 47.5 6.25C33.0025 6.25 21.25 18.0025 21.25 32.5C21.25 46.9975 33.0025 58.75 47.5 58.75Z",
    stroke: "#374354",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 32.5C27.5 21.4538 36.455 12.5 47.5 12.5",
    stroke: "#E53B34",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualSearchIcon);
export default __webpack_public_path__ + "static/media/individual-search-icon.7eb6038efba2456f7d30f27f88c322dc.svg";
export { ForwardRef as ReactComponent };